export interface SpinnerProps {
  size?: 'sm' | 'md';
  /** 显示在圆环下方的提示文案 */
  label?: string;
}

/** 加载态 */
export default function Spinner({ size = 'md', label }: SpinnerProps) {
  return (
    <div className="spinner-wrap">
      <span className={['spinner', size === 'sm' ? 'spinner--sm' : ''].filter(Boolean).join(' ')} />
      {label && <span className="spinner-wrap__label">{label}</span>}
    </div>
  );
}
